var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"add-user-modal",attrs:{"hide-footer":"","size":"xl","centered":"","id":"add-user-modal","title":"Adicionar novo usuário"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1b5b45","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/realestate/pricetablemanagement/components/templatePrice/templatePrice.vue
// module id = null
// module chunks = 